import React from "react";
import { ACTIVITY_TYPE } from "../../enums.js";
import { getResourcesForActivityIds, getResourcesSummary } from "./RpaReservationStepActivity";

/** @typedef {import('../../models/RpaActivityModel.js').RpaActivityItem } RpaActivityItem */
/** @typedef {import('../../services/RpaPlanningService.js').RpaResourcesPerDayObj } RpaResourcesPerDayObj */

/**
 * @typedef {object} RpaReservationStepSportTypeProps
 * @property {Array<RpaActivityItem>} activities - Activités RPA
 * @property {Array<RpaResourcesPerDayObj>} planningDays - Journées du planning
 * @property {?string} selectedSportType - Type de sport sélectionné
 * @property {function(?string):void} onSportTypeChange - Sélection ou désélection d'un type de sport
 */

/**
 * Étape de sélection du type de sport
 * @param {RpaReservationStepSportTypeProps} props
 */
export default function RpaReservationStepSportType({ activities, planningDays, selectedSportType, onSportTypeChange }) {
  const sportTypes = getSportTypes(activities);
  const displayedSportTypes = selectedSportType ? sportTypes.filter(sportType => sportType === selectedSportType) : sportTypes;

  return (
    <section>
      <h3 className="title title--small title--no-margin">Activité</h3>
      <div className="space--16"></div>
      <div className="grid grid--has-6-child grid--8-gap grid--has-2-child-mobile no-mobile">
        {displayedSportTypes.map(sportType => {
          const activityIds = activities.filter(rpaActivity => rpaActivity.activity_type === sportType).map(rpaActivity => Number(rpaActivity.id));
          const resourcesSummary = getResourcesSummary(getResourcesForActivityIds(planningDays, activityIds));

          return (
            <button key={sportType} type="button" className={`btn btn--full btn--flex-column ${sportType === selectedSportType ? "btn--main-color" : "btn--outline-grey"}`} style={{ padding: 0, gap: 0, overflow: "hidden" }} onClick={() => onSportTypeChange(sportType === selectedSportType ? null : sportType)}>
              {!selectedSportType ? <div style={{ width: "100%", height: "200px", backgroundImage: `url(/images/applications/rpa/${sportType}.webp)`, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center", borderRadius: "5px 5px 0 0" }} /> : null}
              <span style={{ display: "flex", flexDirection: "column", gap: "2px", width: "100%", padding: "var(--spacing)" }}>
                <span className="btn__label--bold">{Object.values(ACTIVITY_TYPE).find(activityType => activityType.value === sportType)?.name || sportType}</span>
                {resourcesSummary ? <small className="btn__label--small">({resourcesSummary})</small> : null}
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}

/**
 * Retourne les types de sport uniques des activités
 * TU TODO 🔨
 * @param {Array<RpaActivityItem>} activities - Activités RPA
 * @returns {Array<string>}
 */
export function getSportTypes(activities) {
  return [...new Set(activities.map(rpaActivity => rpaActivity.activity_type).filter(/** @type {(activityType: ?string) => activityType is string} */ (activityType => Boolean(activityType))))];
}
